<template>
  <div class="imagetextmessage">
    <div class="text-wrap">
      <span class="text">这里是受者描述的病情信息，这里是受者描述</span>
    </div>
    <div class="images-wrap">
      <div class="images-list">
        <img
          class="image"
          src="https://pharmacyimg.docbook.com.cn/mini_patient/default-photo.jpg"
        />
      </div>
      <div class="more">
        <span class="more-txt">{{ `共${total}张` }}</span>
        <uni-icons type="uniui-right" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'imImageTextMessage',
  props: {
    value: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      total: 20
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.imagetextmessage {
  padding: 0.512rem;
  border-radius: 0.597333rem;
  background: #ffffff;

  .text-wrap {
    font-size: 0.64rem;
    line-height: 0.938667rem;
    color: #222222;
    word-break: break-all;
    white-space: pre-wrap;
    max-height: 1.877333rem;
    overflow: hidden;
  }

  .images-wrap {
    display: flex;
    align-items: center;
    overflow: hidden;

    .images-list {
      flex: 1;
      overflow: hidden;

      .image {
        margin-right: 0.512rem;
        display: block;
        width: 2.944rem;
        height: 2.944rem;
      }
    }

    .more {
      flex: 0 0 auto;
      display: flex;
      justify-content: flex-end;

      // .more-text {
      font-size: 0.64rem;
      line-height: 0.64rem;
      color: #222222;
      // }
    }
  }
}
</style>
